// prettier-ignore
export const GUEST_LOCALES = [
  "create-account",
  "create-big-account",
  "errors",
  "login",
  "translation",
  "validation"
]

export const APPLICATION_LOCALES = [
  "accept-payment",
  "approval",
  "beneficiary-list",
  "deposit",
  "errors",
  "history",
  "home",
  "international-transaction",
  "not-found",
  "refund",
  "settings",
  "transaction",
  "translation",
  "user-management",
  "validation",
  "verification"
];

export const SANDBOX_LOCALES = ["sandbox", "sandbox-accept-payment"];

export const LANGUAGES = {
  id: {
    key: "id",
    label: "Indonesia",
    flag_key: "ID",
    short_label: "ID",
    code: "IDN"
  },
  en: {
    key: "en",
    label: "English",
    flag_key: "GB",
    short_label: "EN",
    code: "GBR"
  }
};
